let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6ttEd")).then(() => parcelRequire('41dvE'));